/**
 * Symbols emoji category with searchable keywords
 */
export const symbols = {
  name: 'Symbols',
  icon: '❤️',
  emojis: [
    { emoji: '❤️', keywords: ['heart', 'love', 'red', 'valentine', 'romance'] },
    { emoji: '🧡', keywords: ['heart', 'orange', 'love', 'warm', 'affection'] },
    { emoji: '💛', keywords: ['heart', 'yellow', 'love', 'friendship', 'happy'] },
    { emoji: '💚', keywords: ['heart', 'green', 'love', 'jealous', 'nature'] },
    { emoji: '💙', keywords: ['heart', 'blue', 'love', 'trust', 'loyalty'] },
    { emoji: '💜', keywords: ['heart', 'purple', 'love', 'passion', 'romance'] },
    { emoji: '🖤', keywords: ['heart', 'black', 'love', 'dark', 'evil'] },
    { emoji: '🤍', keywords: ['heart', 'white', 'love', 'pure', 'clean'] },
    { emoji: '🤎', keywords: ['heart', 'brown', 'love', 'earth', 'warm'] },
    { emoji: '💔', keywords: ['heart', 'broken', 'sad', 'breakup', 'hurt'] },
    { emoji: '❣️', keywords: ['heart', 'exclamation', 'love', 'passion', 'mark'] },
    { emoji: '💕', keywords: ['hearts', 'two', 'love', 'affection', 'couple'] },
    { emoji: '💞', keywords: ['hearts', 'revolving', 'love', 'romance', 'spin'] },
    { emoji: '💓', keywords: ['heart', 'beating', 'love', 'pulse', 'alive'] },
    { emoji: '💗', keywords: ['heart', 'growing', 'love', 'expand', 'affection'] },
    { emoji: '💖', keywords: ['heart', 'sparkle', 'love', 'shiny', 'special'] },
    { emoji: '💘', keywords: ['heart', 'arrow', 'cupid', 'love', 'valentine'] },
    { emoji: '💝', keywords: ['heart', 'ribbon', 'gift', 'love', 'present'] },
    { emoji: '💟', keywords: ['heart', 'decoration', 'love', 'purple', 'ornament'] },
    { emoji: '☮️', keywords: ['peace', 'symbol', 'hippie', 'love', 'sign'] },
    { emoji: '✝️', keywords: ['cross', 'christian', 'religion', 'church', 'latin'] },
    { emoji: '☪️', keywords: ['star', 'crescent', 'islam', 'muslim', 'religion'] },
    { emoji: '🕉️', keywords: ['om', 'hindu', 'religion', 'symbol', 'spiritual'] },
    { emoji: '☸️', keywords: ['wheel', 'dharma', 'buddhism', 'religion', 'symbol'] },
    { emoji: '✡️', keywords: ['star', 'david', 'jewish', 'religion', 'judaism'] },
    { emoji: '🔯', keywords: ['star', 'hexagram', 'six', 'pointed', 'symbol'] },
    { emoji: '🕎', keywords: ['menorah', 'jewish', 'hanukkah', 'candles', 'religion'] },
    { emoji: '☯️', keywords: ['yin', 'yang', 'balance', 'tao', 'symbol'] },
    { emoji: '☦️', keywords: ['orthodox', 'cross', 'christian', 'religion', 'symbol'] },
    { emoji: '🛐', keywords: ['worship', 'place', 'religion', 'pray', 'symbol'] },
    { emoji: '⛎', keywords: ['ophiuchus', 'zodiac', 'serpent', 'astrology', 'sign'] },
    { emoji: '♈', keywords: ['aries', 'zodiac', 'astrology', 'ram', 'sign'] },
    { emoji: '♉', keywords: ['taurus', 'zodiac', 'astrology', 'bull', 'sign'] },
    { emoji: '♊', keywords: ['gemini', 'zodiac', 'astrology', 'twins', 'sign'] },
    { emoji: '♋', keywords: ['cancer', 'zodiac', 'astrology', 'crab', 'sign'] },
    { emoji: '♌', keywords: ['leo', 'zodiac', 'astrology', 'lion', 'sign'] },
    { emoji: '♍', keywords: ['virgo', 'zodiac', 'astrology', 'maiden', 'sign'] },
    { emoji: '♎', keywords: ['libra', 'zodiac', 'astrology', 'scales', 'sign'] },
    { emoji: '♏', keywords: ['scorpio', 'zodiac', 'astrology', 'scorpion', 'sign'] },
    { emoji: '♐', keywords: ['sagittarius', 'zodiac', 'astrology', 'archer', 'sign'] },
    { emoji: '♑', keywords: ['capricorn', 'zodiac', 'astrology', 'goat', 'sign'] },
    { emoji: '♒', keywords: ['aquarius', 'zodiac', 'astrology', 'water', 'sign'] },
    { emoji: '♓', keywords: ['pisces', 'zodiac', 'astrology', 'fish', 'sign'] },
    { emoji: '🆔', keywords: ['id', 'identity', 'badge', 'identification', 'card'] },
    { emoji: '⚛️', keywords: ['atom', 'science', 'physics', 'nuclear', 'symbol'] },
    { emoji: '☢️', keywords: ['radioactive', 'nuclear', 'radiation', 'danger', 'hazard'] },
    { emoji: '☣️', keywords: ['biohazard', 'danger', 'hazard', 'toxic', 'warning'] },
    { emoji: '📴', keywords: ['phone', 'off', 'mobile', 'silent', 'no'] },
    { emoji: '📳', keywords: ['vibration', 'phone', 'mode', 'silent', 'mobile'] },
    { emoji: '🆚', keywords: ['vs', 'versus', 'against', 'competition', 'battle'] },
    { emoji: '💮', keywords: ['flower', 'white', 'japanese', 'symbol', 'pretty'] },
    { emoji: '🉐', keywords: ['bargain', 'japanese', 'ideograph', 'advantage', 'deal'] },
    { emoji: '㊙️', keywords: ['secret', 'japanese', 'ideograph', 'confidential', 'symbol'] },
    { emoji: '㊗️', keywords: ['congratulations', 'japanese', 'ideograph', 'symbol', 'celebrate'] },
    { emoji: '🅰️', keywords: ['a', 'blood', 'type', 'letter', 'grade'] },
    { emoji: '🅱️', keywords: ['b', 'blood', 'type', 'letter', 'grade'] },
    { emoji: '🆎', keywords: ['ab', 'blood', 'type', 'letter', 'grade'] },
    { emoji: '🆑', keywords: ['cl', 'clear', 'button', 'symbol', 'reset'] },
    { emoji: '🅾️', keywords: ['o', 'blood', 'type', 'letter', 'zero'] },
    { emoji: '🆘', keywords: ['sos', 'help', 'emergency', 'rescue', 'distress'] },
    { emoji: '❌', keywords: ['cross', 'x', 'mark', 'no', 'wrong', 'delete'] },
    { emoji: '⭕', keywords: ['circle', 'o', 'ring', 'hollow', 'round'] },
    { emoji: '🛑', keywords: ['stop', 'sign', 'octagonal', 'red', 'halt'] },
    { emoji: '⛔', keywords: ['no', 'entry', 'prohibited', 'forbidden', 'stop'] },
    { emoji: '📛', keywords: ['name', 'badge', 'tag', 'label', 'id'] },
    { emoji: '🚫', keywords: ['prohibited', 'no', 'forbidden', 'banned', 'not'] },
    { emoji: '💯', keywords: ['hundred', 'percent', 'score', 'perfect', 'full'] },
    { emoji: '💢', keywords: ['anger', 'symbol', 'mad', 'vein', 'frustration'] },
    { emoji: '♨️', keywords: ['hot', 'springs', 'steam', 'onsen', 'bath'] },
    { emoji: '🚷', keywords: ['no', 'pedestrians', 'prohibited', 'walking', 'forbidden'] },
    { emoji: '🚯', keywords: ['no', 'littering', 'prohibited', 'trash', 'forbidden'] },
    { emoji: '🚳', keywords: ['no', 'bicycles', 'prohibited', 'bike', 'forbidden'] },
    { emoji: '🚱', keywords: ['non', 'potable', 'water', 'prohibited', 'drink'] },
    { emoji: '🔞', keywords: ['no', 'minors', 'eighteen', 'adult', 'age'] },
    { emoji: '📵', keywords: ['no', 'mobile', 'phones', 'prohibited', 'cell'] },
    { emoji: '🚭', keywords: ['no', 'smoking', 'prohibited', 'cigarette', 'forbidden'] },
    { emoji: '❗', keywords: ['exclamation', 'mark', 'important', 'attention', 'alert'] },
    { emoji: '❕', keywords: ['exclamation', 'mark', 'white', 'outlined', 'attention'] },
    { emoji: '❓', keywords: ['question', 'mark', 'red', 'what', 'confused'] },
    { emoji: '❔', keywords: ['question', 'mark', 'white', 'outlined', 'what'] },
    { emoji: '‼️', keywords: ['exclamation', 'double', 'bangbang', 'important', 'alert'] },
    { emoji: '⁉️', keywords: ['exclamation', 'question', 'interrobang', 'what', 'surprise'] },
    { emoji: '🔅', keywords: ['dim', 'brightness', 'low', 'sun', 'light'] },
    { emoji: '🔆', keywords: ['bright', 'brightness', 'high', 'sun', 'light'] },
    { emoji: '⚠️', keywords: ['warning', 'caution', 'alert', 'danger', 'sign'] },
    { emoji: '🚸', keywords: ['children', 'crossing', 'sign', 'school', 'caution'] },
    { emoji: '🔱', keywords: ['trident', 'emblem', 'poseidon', 'weapon', 'symbol'] },
    { emoji: '⚜️', keywords: ['fleur', 'de', 'lis', 'scout', 'symbol'] },
    { emoji: '🔰', keywords: ['beginner', 'japanese', 'symbol', 'new', 'driver'] },
    { emoji: '♻️', keywords: ['recycle', 'recycling', 'green', 'environment', 'symbol'] },
    { emoji: '✅', keywords: ['check', 'mark', 'button', 'yes', 'correct', 'done'] },
    { emoji: '❇️', keywords: ['sparkle', 'star', 'green', 'symbol', 'decoration'] },
    { emoji: '✳️', keywords: ['asterisk', 'eight', 'spoked', 'symbol', 'star'] },
    { emoji: '❎', keywords: ['cross', 'mark', 'button', 'x', 'no'] },
    { emoji: '🌐', keywords: ['globe', 'meridians', 'world', 'internet', 'web'] },
    { emoji: '💠', keywords: ['diamond', 'cute', 'flower', 'blue', 'symbol'] },
    { emoji: 'Ⓜ️', keywords: ['m', 'circled', 'metro', 'letter', 'symbol'] },
    { emoji: '🌀', keywords: ['cyclone', 'spiral', 'dizzy', 'hurricane', 'typhoon'] },
    { emoji: '💤', keywords: ['zzz', 'sleep', 'tired', 'snore', 'rest'] },
    { emoji: '🏧', keywords: ['atm', 'bank', 'money', 'cash', 'machine'] },
    { emoji: '🚾', keywords: ['wc', 'toilet', 'restroom', 'bathroom', 'lavatory'] },
    { emoji: '♿', keywords: ['wheelchair', 'accessible', 'disability', 'handicap', 'symbol'] },
    { emoji: '🅿️', keywords: ['parking', 'p', 'car', 'sign', 'lot'] },
    { emoji: '🛗', keywords: ['elevator', 'lift', 'accessibility', 'up', 'down'] },
    { emoji: '🚹', keywords: ['mens', 'restroom', 'male', 'bathroom', 'symbol'] },
    { emoji: '🚺', keywords: ['womens', 'restroom', 'female', 'bathroom', 'symbol'] },
    { emoji: '🚼', keywords: ['baby', 'symbol', 'changing', 'infant', 'child'] },
    { emoji: '⚧️', keywords: ['transgender', 'symbol', 'gender', 'lgbtq', 'identity'] },
    { emoji: '🚻', keywords: ['restroom', 'bathroom', 'toilet', 'wc', 'lavatory'] },
    { emoji: '🚮', keywords: ['litter', 'bin', 'trash', 'sign', 'garbage'] },
    { emoji: '🎦', keywords: ['cinema', 'movie', 'film', 'theater', 'camera'] },
    { emoji: '📶', keywords: ['signal', 'bars', 'antenna', 'mobile', 'network'] },
    { emoji: '🔣', keywords: ['symbols', 'input', 'characters', 'keyboard', 'special'] },
    { emoji: 'ℹ️', keywords: ['information', 'info', 'source', 'help', 'symbol'] },
    { emoji: '🔤', keywords: ['abc', 'alphabet', 'letters', 'input', 'latin'] },
    { emoji: '🔡', keywords: ['abcd', 'lowercase', 'letters', 'input', 'alphabet'] },
    { emoji: '🔠', keywords: ['abcd', 'uppercase', 'letters', 'input', 'alphabet'] },
    { emoji: '🆖', keywords: ['ng', 'no', 'good', 'button', 'symbol'] },
    { emoji: '🆗', keywords: ['ok', 'button', 'yes', 'good', 'symbol'] },
    { emoji: '🆙', keywords: ['up', 'button', 'new', 'cool', 'symbol'] },
    { emoji: '🆒', keywords: ['cool', 'button', 'symbol', 'word', 'awesome'] },
    { emoji: '🆕', keywords: ['new', 'button', 'symbol', 'fresh', 'word'] },
    { emoji: '🆓', keywords: ['free', 'button', 'symbol', 'word', 'gratis'] },
    { emoji: '0️⃣', keywords: ['zero', 'number', 'digit', 'keycap', '0'] },
    { emoji: '1️⃣', keywords: ['one', 'number', 'digit', 'keycap', '1'] },
    { emoji: '2️⃣', keywords: ['two', 'number', 'digit', 'keycap', '2'] },
    { emoji: '3️⃣', keywords: ['three', 'number', 'digit', 'keycap', '3'] },
    { emoji: '4️⃣', keywords: ['four', 'number', 'digit', 'keycap', '4'] },
    { emoji: '5️⃣', keywords: ['five', 'number', 'digit', 'keycap', '5'] },
    { emoji: '6️⃣', keywords: ['six', 'number', 'digit', 'keycap', '6'] },
    { emoji: '7️⃣', keywords: ['seven', 'number', 'digit', 'keycap', '7'] },
    { emoji: '8️⃣', keywords: ['eight', 'number', 'digit', 'keycap', '8'] },
    { emoji: '9️⃣', keywords: ['nine', 'number', 'digit', 'keycap', '9'] },
    { emoji: '🔟', keywords: ['ten', 'number', 'digit', 'keycap', '10'] },
    { emoji: '🔢', keywords: ['numbers', 'input', '1234', 'digits', 'keyboard'] },
    { emoji: '#️⃣', keywords: ['hash', 'hashtag', 'pound', 'number', 'keycap'] },
    { emoji: '*️⃣', keywords: ['asterisk', 'keycap', 'star', 'symbol', 'multiply'] },
    { emoji: '▶️', keywords: ['play', 'button', 'start', 'video', 'forward'] },
    { emoji: '⏸️', keywords: ['pause', 'button', 'stop', 'video', 'wait'] },
    { emoji: '⏯️', keywords: ['play', 'pause', 'button', 'toggle', 'video'] },
    { emoji: '⏹️', keywords: ['stop', 'button', 'square', 'video', 'end'] },
    { emoji: '⏺️', keywords: ['record', 'button', 'circle', 'video', 'audio'] },
    { emoji: '⏭️', keywords: ['next', 'track', 'button', 'skip', 'forward'] },
    { emoji: '⏮️', keywords: ['previous', 'track', 'button', 'back', 'rewind'] },
    { emoji: '⏩', keywords: ['fast', 'forward', 'button', 'speed', 'skip'] },
    { emoji: '⏪', keywords: ['rewind', 'button', 'back', 'fast', 'reverse'] },
    { emoji: '⏫', keywords: ['fast', 'up', 'button', 'arrow', 'double'] },
    { emoji: '⏬', keywords: ['fast', 'down', 'button', 'arrow', 'double'] },
    { emoji: '◀️', keywords: ['reverse', 'button', 'left', 'back', 'play'] },
    { emoji: '🔼', keywords: ['up', 'button', 'arrow', 'triangle', 'increase'] },
    { emoji: '🔽', keywords: ['down', 'button', 'arrow', 'triangle', 'decrease'] },
    { emoji: '➡️', keywords: ['right', 'arrow', 'direction', 'forward', 'next'] },
    { emoji: '⬅️', keywords: ['left', 'arrow', 'direction', 'back', 'previous'] },
    { emoji: '⬆️', keywords: ['up', 'arrow', 'direction', 'north', 'top'] },
    { emoji: '⬇️', keywords: ['down', 'arrow', 'direction', 'south', 'bottom'] },
    { emoji: '↗️', keywords: ['arrow', 'northeast', 'direction', 'diagonal', 'up'] },
    { emoji: '↘️', keywords: ['arrow', 'southeast', 'direction', 'diagonal', 'down'] },
    { emoji: '↙️', keywords: ['arrow', 'southwest', 'direction', 'diagonal', 'down'] },
    { emoji: '↖️', keywords: ['arrow', 'northwest', 'direction', 'diagonal', 'up'] },
    { emoji: '↕️', keywords: ['arrow', 'up', 'down', 'vertical', 'direction'] },
    { emoji: '↔️', keywords: ['arrow', 'left', 'right', 'horizontal', 'direction'] },
    { emoji: '↪️', keywords: ['arrow', 'curving', 'right', 'turn', 'direction'] },
    { emoji: '↩️', keywords: ['arrow', 'curving', 'left', 'return', 'back'] },
    { emoji: '⤴️', keywords: ['arrow', 'heading', 'up', 'direction', 'curve'] },
    { emoji: '⤵️', keywords: ['arrow', 'heading', 'down', 'direction', 'curve'] },
    { emoji: '🔀', keywords: ['shuffle', 'crossed', 'arrows', 'random', 'mix'] },
    { emoji: '🔁', keywords: ['repeat', 'loop', 'arrows', 'cycle', 'again'] },
    { emoji: '🔂', keywords: ['repeat', 'one', 'loop', 'single', 'track'] },
    { emoji: '🔄', keywords: ['arrows', 'counterclockwise', 'refresh', 'reload', 'sync'] },
    { emoji: '🔃', keywords: ['arrows', 'clockwise', 'vertical', 'refresh', 'reload'] },
    { emoji: '🎵', keywords: ['music', 'note', 'sound', 'melody', 'song'] },
    { emoji: '🎶', keywords: ['music', 'notes', 'sound', 'melody', 'song'] },
    { emoji: '➕', keywords: ['plus', 'add', 'math', 'positive', 'increase'] },
    { emoji: '➖', keywords: ['minus', 'subtract', 'math', 'negative', 'decrease'] },
    { emoji: '➗', keywords: ['divide', 'division', 'math', 'split', 'calculate'] },
    { emoji: '✖️', keywords: ['multiply', 'x', 'math', 'times', 'calculate'] },
    { emoji: '♾️', keywords: ['infinity', 'forever', 'endless', 'math', 'loop'] },
    { emoji: '💲', keywords: ['dollar', 'money', 'sign', 'currency', 'cash'] },
    { emoji: '💱', keywords: ['currency', 'exchange', 'money', 'convert', 'rate'] },
    { emoji: '™️', keywords: ['trademark', 'tm', 'brand', 'registered', 'symbol'] },
    { emoji: '©️', keywords: ['copyright', 'c', 'rights', 'reserved', 'symbol'] },
    { emoji: '®️', keywords: ['registered', 'r', 'trademark', 'brand', 'symbol'] },
    { emoji: '〰️', keywords: ['wavy', 'dash', 'line', 'punctuation', 'symbol'] },
    { emoji: '➰', keywords: ['curly', 'loop', 'curl', 'symbol', 'decoration'] },
    { emoji: '➿', keywords: ['double', 'curly', 'loop', 'symbol', 'decoration'] },
    { emoji: '🔚', keywords: ['end', 'arrow', 'finish', 'final', 'last'] },
    { emoji: '🔙', keywords: ['back', 'arrow', 'return', 'previous', 'left'] },
    { emoji: '🔛', keywords: ['on', 'arrow', 'mark', 'switch', 'active'] },
    { emoji: '🔝', keywords: ['top', 'arrow', 'up', 'best', 'first'] },
    { emoji: '🔜', keywords: ['soon', 'arrow', 'coming', 'future', 'next'] },
    { emoji: '✔️', keywords: ['check', 'mark', 'yes', 'correct', 'done', 'tick'] },
    { emoji: '☑️', keywords: ['check', 'box', 'ballot', 'vote', 'done'] },
    { emoji: '🔘', keywords: ['radio', 'button', 'circle', 'option', 'select'] },
    { emoji: '🔴', keywords: ['red', 'circle', 'dot', 'round', 'color'] },
    { emoji: '🟠', keywords: ['orange', 'circle', 'dot', 'round', 'color'] },
    { emoji: '🟡', keywords: ['yellow', 'circle', 'dot', 'round', 'color'] },
    { emoji: '🟢', keywords: ['green', 'circle', 'dot', 'round', 'color'] },
    { emoji: '🔵', keywords: ['blue', 'circle', 'dot', 'round', 'color'] },
    { emoji: '🟣', keywords: ['purple', 'circle', 'dot', 'round', 'color'] },
    { emoji: '⚫', keywords: ['black', 'circle', 'dot', 'round', 'color'] },
    { emoji: '⚪', keywords: ['white', 'circle', 'dot', 'round', 'color'] },
    { emoji: '🟤', keywords: ['brown', 'circle', 'dot', 'round', 'color'] },
    { emoji: '🔺', keywords: ['red', 'triangle', 'up', 'pointed', 'shape'] },
    { emoji: '🔻', keywords: ['red', 'triangle', 'down', 'pointed', 'shape'] },
    { emoji: '🔸', keywords: ['orange', 'diamond', 'small', 'shape', 'rhombus'] },
    { emoji: '🔹', keywords: ['blue', 'diamond', 'small', 'shape', 'rhombus'] },
    { emoji: '🔶', keywords: ['orange', 'diamond', 'large', 'shape', 'rhombus'] },
    { emoji: '🔷', keywords: ['blue', 'diamond', 'large', 'shape', 'rhombus'] },
    { emoji: '🔳', keywords: ['white', 'square', 'button', 'shape', 'outline'] },
    { emoji: '🔲', keywords: ['black', 'square', 'button', 'shape', 'outline'] },
    { emoji: '▪️', keywords: ['black', 'square', 'small', 'shape', 'dot'] },
    { emoji: '▫️', keywords: ['white', 'square', 'small', 'shape', 'dot'] },
    { emoji: '◾', keywords: ['black', 'square', 'medium', 'small', 'shape'] },
    { emoji: '◽', keywords: ['white', 'square', 'medium', 'small', 'shape'] },
    { emoji: '◼️', keywords: ['black', 'square', 'medium', 'shape', 'fill'] },
    { emoji: '◻️', keywords: ['white', 'square', 'medium', 'shape', 'outline'] },
    { emoji: '🟥', keywords: ['red', 'square', 'shape', 'color', 'block'] },
    { emoji: '🟧', keywords: ['orange', 'square', 'shape', 'color', 'block'] },
    { emoji: '🟨', keywords: ['yellow', 'square', 'shape', 'color', 'block'] },
    { emoji: '🟩', keywords: ['green', 'square', 'shape', 'color', 'block'] },
    { emoji: '🟦', keywords: ['blue', 'square', 'shape', 'color', 'block'] },
    { emoji: '🟪', keywords: ['purple', 'square', 'shape', 'color', 'block'] },
    { emoji: '⬛', keywords: ['black', 'square', 'large', 'shape', 'block'] },
    { emoji: '⬜', keywords: ['white', 'square', 'large', 'shape', 'block'] },
    { emoji: '🟫', keywords: ['brown', 'square', 'shape', 'color', 'block'] },
    { emoji: '🔈', keywords: ['speaker', 'low', 'volume', 'sound', 'audio'] },
    { emoji: '🔇', keywords: ['muted', 'speaker', 'silent', 'no', 'sound'] },
    { emoji: '🔉', keywords: ['speaker', 'medium', 'volume', 'sound', 'audio'] },
    { emoji: '🔊', keywords: ['speaker', 'high', 'volume', 'loud', 'sound'] },
    { emoji: '🔔', keywords: ['bell', 'notification', 'alert', 'ring', 'sound'] },
    { emoji: '🔕', keywords: ['bell', 'no', 'slash', 'mute', 'silent'] },
    { emoji: '📣', keywords: ['megaphone', 'cheering', 'announcement', 'loud', 'speaker'] },
    { emoji: '📢', keywords: ['loudspeaker', 'announcement', 'public', 'address', 'sound'] },
  ],
};

export default symbols;

